<div class="my-4 mx-5">
    <div class="wrapper mb-5">
        <div class="row align-items-center m-0" style="padding: 10px;">
            <img class="p-2" src="./assets/icons/arrow.svg">
            <span class="label-title ml-2 mr-3">Cartões</span>
        </div>
        <div class="row" >
            <div class="mb-0 mt-4 col-md-9 p-0 pr-3">
                <div class="mb-4 alert alert-light" role="alert">
                    <div class="row p-3">
                        <div class="p-0 mx-3 align-self-center">
                            <img src="../../../../../../assets/icons/logo_icon.svg" alt="" height="50px" class="">
                        </div>
                        <div class="col-11 p-0 m-0 align-self-center">
                            <p class="m-0">
                                Aqui você faz a solicitação de cartões Bankei para seus favorecidos.
                                <!-- <br>Antes de iniciar o seu pedido é necessário que você já tenha realizado o cadastro prévio dos favorecidos, caso ainda não tenha feito, <a href="/portal/colaborador/create">clique aqui.</a> -->
                                <br>O limite de cartões que sua empresa poderá solicitar tem como base o número de favorecidos cadastrados.
                                <br>Você pode escolher que os cartões sejam entregues no endereço da sua empresa ou diretamente na residência do favorecido.
                                <br>Verifique se os favorecidos foram cadastrados antes de solicitar novos cartões.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="component-box container-fluid m-0">
                    <div class="container-fluid pt-4">
                        <h5>Pedir Cartões</h5>
                        <div class="row pb-4">
                            <div class="col-5">
                                <p class="pb-0 mb-0">Limite de cartões permitidos: <b>{{cardsLimits.cardsLimit}}</b></p>
                                <mat-form-field class="w-75 mb-2">
                                    <mat-label>Quantidade de cartões</mat-label>
                                    <input matInput onlyNumber [formControl]="quantityCardsCtrl" id="quantityCards" (ngModelChange)="setTotalQuantityCards()" [readonly]="disableQuantityInput">
                                    <mat-error *ngIf="quantityCardsCtrl.hasError('required')" >Insira uma quantidade de cartões</mat-error>

                                </mat-form-field>
                                <mat-checkbox class="" color="primary" (change)="showCollaborators($event.checked)">Pedir cartão (entrega direta ao favorecido)</mat-checkbox>
                            </div>
                            <div class="col-5">
                                    <h5>Endereço de Entrega</h5>
                                    <p>
                                        <b>{{assignorInfo.nickName}}</b><br>
                                        {{assignorAddressInfo.addressName}}, {{assignorAddressInfo.number}} {{assignorAddressInfo.complement ? ', '+assignorAddressInfo.complement : ''}} - {{assignorAddressInfo.neighborhood}}<br>
                                        {{assignorAddressInfo.city}} - {{assignorAddressInfo.uf}} - {{assignorAddressInfo.zipCode | cep}}<br>
                                    </p>
                            </div>
                        </div>
                        <ng-container *ngIf="showcollaborators">
                            <div class="row mt-0">
                                <div class="col-md-12 text-right">
                                    <ul class="options-cadastro m-0">
                                        <li>
                                            <div *ngIf="filtroOn" (click)="deleteFilter(filtro)" class="list-select ml-2
                                                my-1">
                                                <button class="list-select-delete" type="button">
                                                    Apagar filtro
                                                </button>
                                            </div>
                                        </li>
                                        <li>
                                            <div (click)="showFilter(filtro)" class="list-select ml-2
                                                my-1">
                                                <button class="list-select"  type="button">
                                                    <span *ngIf="!filtroOn"><img src="assets/icons/filter.svg" style="height: 15px;"> Aplicar filtro</span>
                                                    <span *ngIf="filtroOn"><img src="assets/icons/filter-purple.svg" style="height: 15px;"> Alterar filtro</span>
                                                </button>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="list-filter-show-item ml-2 my-1">
                                                Mostrar:
                                                <select (change)="showItemChanged($event.target.value)" class="ng-untouched ng-pristine ng-valid" [value]="showItem">
                                                    <option _ selected="" value="10">10</option>
                                                    <option value="25">25</option>
                                                    <option value="50">50</option>
                                                    <option value="100">100</option>
                                                </select>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="row">
                                <div class="table-responsive" *ngIf="totalItems > 0">
                                    <table class="list-table table table-striped">
                                        <thead class="list-table-head">
                                            <th></th>
                                            <th class="">
                                                Nome
                                            </th>
                                            <th class="">
                                                CPF
                                            </th>
                                            <th>
                                                Endereço
                                            </th>
                                        </thead>
                                        <tbody class="list-table-row">
                                            <tr *ngFor="let item of collaborators | paginate : { itemsPerPage: showItem, currentPage: currentPage, totalItems: totalItems }"  class="list-table-cell">
                                                <td>
                                                    <span>
                                                        <input [attr.id]="item.collaboratorId" type="checkbox" class="radio-checkbox" [(ngModel)]="item.selected" (click)="selectElement(item)"/>
                                                        <label [attr.for]="item.collaboratorId" class="radio-label"></label>
                                                    </span>
                                                </td>
                                                <td>{{item.collaboratorName}} </td>
                                                <td>
                                                    <span>{{ item.collaboratorDocument }}</span>
                                                </td>
                                                <td>
                                                    <span (click)="editAddress(item)">
                                                        <input [attr.id]="item.collaboratorDocument" type="checkbox" class="radio-checkbox" [(ngModel)]="item.useAddress" [disabled]="true"/>
                                                        <label [attr.for]="item.collaboratorDocument" class="radio-label">
                                                            <span class="ml-2 mr-2" [ngStyle]="{'color': (!item.selected || !item.collaboratorHasAddress) ?  '#7d7d7d' : '#212529'}">Utilizar Endereço</span>
                                                        </label>
                                                        <!-- <button class="action-button" style="height: auto;">Cadastrar endereço</button> -->
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div class="page-custom mt-2">
                                        <pagination-controls (pageChange)="changePage($event)" responsive="true" previousLabel="" nextLabel=""></pagination-controls>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="totalItems === 0" class="justify-content-center">
                                <h6 class="text-center py-5">
                                    Nenhum favorecido foi encontrado.
                                </h6>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
            <div class="mb-0 mt-4 col-md-3 p-0 pl-3">
                <div class="component-box container-fluid m-0 resume">
                    <div class="container-fluid py-4">
                        <h5>Resumo Pedido Cartão</h5>
                        <p class="py-0">Cartões para a empresa: <b>{{quantityCards}}</b></p>
                        <p class="py-0">Cartões para o colaborador: <b>{{count}}</b></p>
                        <!-- <p class="pt-0">Acréscimo de cartões: <b>{{cardsLimits.cardsAdditionValue}}</b></p> -->
                        <hr>
                        <p class="pb-4" style="font-size: 0.969rem">Quantidade Total de Cartões: <b>{{totalQuantityCards}}</b></p>
                        <button class="action-button w-100" style="height: auto;" (click)="solicitCard()">Pedir Cartões</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--Modal de Aviso-->
<ng-template #modalAvisoEndereco let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="modal-title clean-modal-title">
                Endereço de correspondência
            </h5>
            <p class="clean-modal-subtitle" style="font-size: 20px;">
                A empresa não tem uma endereço de correspondência cadastrado!<br>
            </p>
        </div>
    </div>
    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button button-cancel mr-2" type="button" (click)="modal.dismiss('Close click');navigateToPedidoList()">Fechar</button>
        <button class="custom-filter-button custom-filter-button-just" type="button" type="button" (click)="navigateToAssignorInfoEdit();modal.dismiss('Close click')">Cadastrar agora</button>
    </div>
</ng-template>

<!--Modal de Aviso-->
<ng-template #modalAvisoLimite let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="modal-title clean-modal-title">
                Limite de cartões
            </h5>
            <p class="clean-modal-subtitle" style="font-size: 20px;">
                Não é possível mais solicitar cartões! <br>
                Quantidade de cartões solicitados excede a quantidade de favorecidos.
            </p>
        </div>
    </div>
    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button button-cancel mr-2" type="button" (click)="modal.dismiss('Close click');navigateToPedidoList()">Fechar</button>
        <!-- <button class="custom-filter-button custom-filter-button-just" type="button" type="button" (click)="cancel(solicitationToCancel);modal.dismiss('Close click')">Sim</button> -->
    </div>
</ng-template>

<!--Modal de Aviso-->
<ng-template #modalAvisoColaboradores let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="modal-title clean-modal-title">
                Favorecidos
            </h5>
            <p class="clean-modal-subtitle" style="font-size: 20px;">
                Não existe favorecido cadastrado para realizar um pedido de cartões.<br>
                Faça o cadastro!
            </p>
        </div>
    </div>
    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button button-cancel mr-2" type="button" (click)="modal.dismiss('Close click');navigateToPedidoList()">Fechar</button>
        <button class="custom-filter-button custom-filter-button-just" style="background-position: 90% 50%" type="button" type="button" (click)="modal.dismiss('Close click');navigateToCadastroColaborador();">Cadastrar Favorecido</button>
    </div>
</ng-template>

<!--Modal de Endereco-->
<ng-template #modalEndereco let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="modal-title clean-modal-title">
                {{addressModalLabel}} endereço do favorecido
            </h5>
            <p *ngIf="!isEditing" class="clean-modal-subtitle" style="font-size: 20px;">
                Este favorecido não tem um endereço cadastrado.<br>
                Cadastre agora!
            </p>
            <p *ngIf="isEditing" class="clean-modal-subtitle" style="font-size: 20px;">
                Este favorecido tem um endereço cadastrado.<br>
                Atualize agora!
            </p>
        </div>
    </div>
    <div class="col-12 clean-modal-content">
        <form [formGroup]="collaboratorAddressFormGroup">
            <ng-template matStepLabel>Dados pessoais</ng-template>
            <h5>Endereço</h5>
            <mat-form-field class="w-25">
                <mat-label>CEP</mat-label>
                <input matInput formControlName="cep" [textMask]="{mask: MASKS.cep.textMask}" (blur)="getAddressZipCode(collaboratorAddressFormGroup.get('cep').value)">
                <mat-error *ngIf="(collaboratorAddressFormGroup.get('cep').invalid && (collaboratorAddressFormGroup.get('cep').dirty || collaboratorAddressFormGroup.get('cep').touched)) && collaboratorAddressFormGroup.get('cep').errors.required">
                    CEP é obrigatório!
                </mat-error>
            </mat-form-field>
            <table class="w-75" cellspacing="0">
                <tr>
                    <td>
                        <mat-form-field class="w-75">
                        <mat-label>Endereço</mat-label>
                            <input matInput formControlName="address">
                        </mat-form-field>
                        <mat-error *ngIf="(collaboratorAddressFormGroup.get('address').invalid && (collaboratorAddressFormGroup.get('address').dirty || collaboratorAddressFormGroup.get('address').touched)) && collaboratorAddressFormGroup.get('address').errors.required">
                            Endereço é obrigatório!
                        </mat-error>
                    </td>
                    <td>
                        <mat-form-field class="w-75">
                        <mat-label>Número</mat-label>
                            <input matInput formControlName="number" maxlength="10" (change)="semNumero(collaboratorAddressFormGroup.get('number').value)">
                        </mat-form-field>
                        <mat-error *ngIf="(collaboratorAddressFormGroup.get('number').invalid && (collaboratorAddressFormGroup.get('number').dirty || collaboratorAddressFormGroup.get('number').touched)) && collaboratorAddressFormGroup.get('number').errors.required">
                            Número é obrigatório!
                        </mat-error>
                    </td>
                </tr>
                <tr>
                    <td>
                        <mat-form-field class="w-75">
                        <mat-label>Complemento</mat-label>
                            <input formControlName="complement" matInput >
                        </mat-form-field>
                    </td>
                    <td>
                        <mat-form-field class="w-75">
                        <mat-label>Bairro</mat-label>
                            <input matInput formControlName="neighborhood">
                        </mat-form-field>
                        <mat-error *ngIf="(collaboratorAddressFormGroup.get('neighborhood').invalid && (collaboratorAddressFormGroup.get('neighborhood').dirty || collaboratorAddressFormGroup.get('neighborhood').touched)) && collaboratorAddressFormGroup.get('neighborhood').errors.required">
                            Bairro é obrigatório!
                        </mat-error>
                    </td>
                </tr>
                <tr>
                    <td>
                        <mat-form-field class="w-75">
                        <mat-label>Cidade</mat-label>
                            <input matInput formControlName="city" [readonly]="emptyCity">
                        </mat-form-field>
                        <mat-error *ngIf="(collaboratorAddressFormGroup.get('city').invalid && (collaboratorAddressFormGroup.get('city').dirty)) && collaboratorAddressFormGroup.get('city').errors.required" >
                            Cidade é obrigatório!
                        </mat-error>
                    </td>
                    <td>
                        <mat-form-field class="w-75">
                        <mat-label>Estado</mat-label>
                            <input matInput formControlName="uf" maxlength="2" [readonly]="emptyUf">
                        </mat-form-field>
                        <mat-error *ngIf="(collaboratorAddressFormGroup.get('uf').invalid && (collaboratorAddressFormGroup.get('uf').dirty)) && collaboratorAddressFormGroup.get('uf').errors.required">
                            Estado é obrigatório!
                        </mat-error>
                    </td>
                </tr>
            </table>
        </form>
    </div>
    <div class="col-12 clean-modal-footer">
        <button *ngIf="!isEditing" class="custom-filter-button button-cancel mr-2" type="button" (click)="modal.dismiss('Close click');addressDismiss()" ngbAutofocus>Fechar</button>
        <button *ngIf="!isEditing" class="custom-filter-button custom-filter-button-just" style="background-position: 90% 50%" type="button" type="button" (click)="modal.dismiss('Close click');createAddress();">Cadastrar Endereço</button>

        <button *ngIf="isEditing"class="custom-filter-button button-cancel mr-2" type="button" (click)="modal.dismiss('Close click');" ngbAutofocus>Fechar</button>
        <button *ngIf="isEditing" class="custom-filter-button custom-filter-button-just" style="background-position: 90% 50%" type="button" type="button" (click)="modal.dismiss('Close click');updateAddress();">Editar Endereço</button>
    </div>

</ng-template>


<!--Modal do Filtro-->
<ng-template #filtro let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Aplicar filtro</h5>
        </div>
    </div>
    <div class="row col-12 clean-modal-content">
        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <mat-form-field>
                    <mat-label>Nome</mat-label>
                    <input [formControl]="nameCtrl" matInput type="text" [(ngModel)]="filtroNome" id="name">
                    <button mat-button *ngIf="filtroNome" matSuffix mat-icon-button aria-label="Clear" (click)="filtroNome=''">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <mat-form-field>
                <mat-label>CPF</mat-label>
                <input [formControl]="documentCtrl" matInput type="text" [(ngModel)]="filtroDocumento" id="document">
                <button mat-button *ngIf="filtroDocumento" matSuffix mat-icon-button aria-label="Clear" (click)="filtroDocumento=''">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </div>
    </div>
    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button custom-filter-button-just" type="button" (click)="applyFilter();modal.dismiss('Close click')" ngbAutofocus>
            Aplicar
        </button>
    </div>
</ng-template>

